import { ApiResponse } from '@oncolens/oncolens-ui/lib/dto/api/ApiResponse';
import api from '@/utils/httpClient';

export interface RequestPatientDto {
	id: string;
	sexId: string;
	sexConfig: RequestPatientSexDto;
	raceId?: string;
	ethnicityId?: string;
	zip: string;
	age: number;
	organizationId?: string;
}
export interface RequestPatientSexDto {
	value: string;
}
export interface RequestPatientForManipulationDto {
	sexId: string;
	raceId?: string;
	ethnicityId?: string;
	zip: string;
	age: number;
	organizationId: string;
}

export const createPatient = (data: RequestPatientForManipulationDto) => {
  return api
    .post('/api/patients', data)
    .then((response) => (response.data as ApiResponse<RequestPatientDto>).data);
};
